module.exports = __webpack_public_path__ + "img/1.3.a261d5fc.png";